import { createTheme } from '@one-thd/sui-atomic-components';

const THDTombstoneGreen = createTheme({
  palette: {
    mode: 'dark',
    background: {
      primary: 'brand-500'
    }
  }
});

THDTombstoneGreen.palette['--sui-palette-background-primary'] = '140 144 117';

export { THDTombstoneGreen };
